import { occBaseSiteUrl, occFetch } from "~/app/api/occ/occFetch";
import type { ErrorCode } from "~/features/cart/cart/api/placeOrder";
import { resolveActiveCartResourceId } from "~/features/cart/cart/utils/cartResourceIdentity";

interface PlaceQuoteOrderResponse {
  success: boolean;
  errorCode?: ErrorCode;
  orderCode?: string;
}

export async function apiSubmitQuotePlaceOrder(fccOnly: boolean) {
  const activeCartId = await resolveActiveCartResourceId();
  if (!activeCartId) {
    throw new Error("Cannot place a quote without an explicit Active Cart identity");
  }

  const response = await occFetch(
    occBaseSiteUrl(`/users/current/carts/${encodeURIComponent(activeCartId)}/quote/placeOrder`),
    {
      body: JSON.stringify({ fccOnly }),
      method: "POST",
      headers: { "Content-Type": "application/json" },
    },
  );
  return response.json() as Promise<PlaceQuoteOrderResponse>;
}
